/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Task_Flow_Inactive_ResolutionsInputs */

const en_task_flow_inactive_resolutions = /** @type {(inputs: Task_Flow_Inactive_ResolutionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inactive resolutions (${i?.count})`)
};

const pt_br2_task_flow_inactive_resolutions = /** @type {(inputs: Task_Flow_Inactive_ResolutionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resoluções inativas (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Inactive resolutions ({count})" |
*
* @param {Task_Flow_Inactive_ResolutionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_inactive_resolutions = /** @type {((inputs: Task_Flow_Inactive_ResolutionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Inactive_ResolutionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_inactive_resolutions(inputs)
	return pt_br2_task_flow_inactive_resolutions(inputs)
});